// extracted by mini-css-extract-plugin
export default {"container":"z_-z","list":"A_-z"};